// Generated by purs version 0.15.15
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Ouroboros_Models_Brands_ErrorInfoText from "../Ouroboros.Models.Brands.ErrorInfoText/index.js";
import * as Ouroboros_Models_Brands_ErrorMessageText from "../Ouroboros.Models.Brands.ErrorMessageText/index.js";
import * as Ouroboros_Models_Core_ErrorHandlers from "../Ouroboros.Models.Core.ErrorHandlers/index.js";
import * as Ouroboros_Programs_Capabilities from "../Ouroboros.Programs.Capabilities/index.js";
import * as Ouroboros_Services_Clients_Interop_IO from "../Ouroboros.Services.Clients.Interop.IO/index.js";
import * as Ouroboros_Services_Clients_Interop_Option from "../Ouroboros.Services.Clients.Interop.Option/index.js";
import * as Ouroboros_Services_Clients_Interop_Task from "../Ouroboros.Services.Clients.Interop.Task/index.js";
import * as Ouroboros_Services_Clients_Interop_TaskEither from "../Ouroboros.Services.Clients.Interop.TaskEither/index.js";
var DocumentSelectionAction = function (x) {
    return x;
};
var toLoadingErrorInput = function (errorValue) {
    var statusCode = (function () {
        if (errorValue.statusCode instanceof Data_Maybe.Nothing) {
            return Ouroboros_Services_Clients_Interop_Option.none(Data_Unit.unit);
        };
        if (errorValue.statusCode instanceof Data_Maybe.Just) {
            return Ouroboros_Services_Clients_Interop_Option.some(errorValue.statusCode.value0);
        };
        throw new Error("Failed pattern match at Ouroboros.Programs.Controllers.DocumentSelection (line 153, column 7 - line 155, column 40): " + [ errorValue.statusCode.constructor.name ]);
    })();
    var message = Ouroboros_Models_Core_ErrorHandlers.lifecycleErrorMessage({
        type: errorValue.type,
        message: errorValue.message,
        statusCode: statusCode
    });
    return {
        message: message.message,
        info: message.info
    };
};
var runNavigate = function (v) {
    return function (path) {
        return v(path);
    };
};
var runLoadingAction = function (v) {
    return v;
};
var runDocumentSelectionAction = function (v) {
    return v;
};
var navigateToReviewPage = function (env) {
    return function (document) {
        return Ouroboros_Services_Clients_Interop_IO.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_IO.chain(function (v1) {
                return runNavigate(env.navigate)(Ouroboros_Programs_Capabilities.runRouteBuilder(env.reviewRoute)(document.id));
            })(runLoadingAction(env.loading.setSuccess));
        })(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.optionStateHandleSetSome(env.document))(document));
    };
};
var mkDocumentSelectionAction = DocumentSelectionAction;
var handleLifecycleError = function (env) {
    return function (errorValue) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError(toLoadingErrorInput(errorValue))));
    };
};
var handleFetchDocumentsSuccess = function (env) {
    return function (response) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runStateUpdate(Ouroboros_Programs_Capabilities.stateHandleSet(env.availableDocuments))(response.documents)));
    };
};
var handleFetchDocumentsError = function (env) {
    return function (errorValue) {
        var message = Ouroboros_Models_Brands_ErrorMessageText.makeErrorMessageText("Failed to fetch documents");
        var info = Ouroboros_Services_Clients_Interop_Option.some(Ouroboros_Models_Brands_ErrorInfoText.makeErrorInfoText(Ouroboros_Models_Brands_ErrorMessageText.unwrap(errorValue.message)));
        return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setError({
            message: message,
            info: info
        })));
    };
};
var handleDownloadSuccess = function (env) {
    return function (title) {
        return function (blob) {
            return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
                return Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setSuccess));
            })(Ouroboros_Services_Clients_Interop_Task.fromIO(Ouroboros_Programs_Capabilities.runBlobHandler(env.downloadDocument)(blob)(title)));
        };
    };
};
var handleDocumentSelectionSuccess = function (env) {
    return function (document) {
        return Ouroboros_Services_Clients_Interop_Task.fromIO(navigateToReviewPage(env)(document));
    };
};
var selectDocumentTask = function (env) {
    return function (documentId) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env))(handleDocumentSelectionSuccess(env))(env.lifecycle.fetchDocument(documentId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var fetchDocumentsTask = function (env) {
    return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
        return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleFetchDocumentsError(env))(handleFetchDocumentsSuccess(env))(env.lifecycle.listAvailableDocuments);
    })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
};
var downloadDocumentTask = function (env) {
    return function (payload) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env))(handleDownloadSuccess(env)(payload.title))(env.lifecycle.downloadDocumentAsBlob(payload.documentId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var documentationPath = "/documentation/drafting/frontend-program-builder/controllers/document_selection_controller.md";
var deleteDocumentTask = function (env) {
    return function (documentId) {
        return Ouroboros_Services_Clients_Interop_Task.chain(function (v) {
            return Ouroboros_Services_Clients_Interop_TaskEither.fold(handleLifecycleError(env))(function (v1) {
                return fetchDocumentsTask(env);
            })(env.lifecycle.deleteDocument(documentId));
        })(Ouroboros_Services_Clients_Interop_Task.fromIO(runLoadingAction(env.loading.setLoading)));
    };
};
var mkDocumentSelectionController = function (env) {
    return {
        onCreateDocument: mkDocumentSelectionAction(runNavigate(env.navigate)(env.documentCreationRoute)),
        onSelectDocument: function (documentId) {
            return mkDocumentSelectionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(selectDocumentTask(env)(documentId)));
        },
        onDownloadDocument: function (payload) {
            return mkDocumentSelectionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(downloadDocumentTask(env)(payload)));
        },
        onDeleteDocument: function (documentId) {
            return mkDocumentSelectionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(deleteDocumentTask(env)(documentId)));
        },
        onInit: mkDocumentSelectionAction(Ouroboros_Programs_Capabilities.runTaskRunner(env.taskRunner)(fetchDocumentsTask(env)))
    };
};
export {
    DocumentSelectionAction,
    mkDocumentSelectionController,
    runDocumentSelectionAction,
    documentationPath
};
//# sourceMappingURL=index.js.map
